module.exports = __webpack_public_path__ + "static/media/overview.3d605b62.svg";